var win_w 	= 0;
var carousel_fade_speed     = 1000;
var carousel_change         = false;
var carousel_interval       = 0;
var carousel_current_index  = 0;
var next_carousel_index     = 1;
var carousel_interval_speed = 7000;
var carousel_num_items      = 0;
var HEADER_OFFSET           = 95;

jQuery(document).ready(function($) {
	win_w = $(document).width();

  init_ui();

  // Mobile navi
  $('button.hamburger').click(function() {
    $(this).find('span#nav-icon').toggleClass('open');
    $(this).toggleClass('open');
    $('body').toggleClass('navi-open');
    if ( $('body.navi-open').length > 0 ) {
      $('nav.main-navi').slideDown(300);
      $(this).attr('aria-expanded', 'true');
    }
    else {
      $('nav.main-navi').hide();
      $(this).attr('aria-expanded', 'false');
    }
  });

  if ( win_w < 1160 ) {
    $('li.menu-item-has-children > a').click(function(e) {
      if ( !$(this).hasClass('open') ) {
        e.preventDefault();
        $(this).addClass('open');
        $(this).parent().find('ul').show();
      }
      else {
        $(this).removeClass('open');
      }
    });
  }

  // Carousel
  if ( $('div.carousel-items').length > 0 ) {
    set_carousel_navi();
    carousel_num_items  = $('div.carousel-items').children().length;
    if ( carousel_num_items > 1 ) {
      carousel_interval = setInterval('carousel_play()', carousel_interval_speed);
    }
    $('div.carousel-navi a').click(function(e) {
      e.preventDefault();
      if ( !carousel_change ) {
        clearInterval(carousel_interval);
        next_carousel_index = $(this).index();
        change_carousel(next_carousel_index);
      }
    });
    $('a.next-item-link').click(function(e) {
      e.preventDefault();
      if ( !carousel_change ) {
        clearInterval(carousel_interval);
        if ( carousel_current_index < carousel_num_items - 1 )
          next_carousel_index = carousel_current_index + 1;
        else
          next_carousel_index = 0;
        change_carousel(next_carousel_index);
      }
    });
    $('a.prev-item-link').click(function(e) {
      e.preventDefault();
      if ( !carousel_change ) {
        clearInterval(carousel_interval);
        if ( carousel_current_index == 0 )
          next_carousel_index = carousel_num_items - 1; 
        else
          next_carousel_index = carousel_current_index - 1;
        change_carousel(next_carousel_index);
      }
    });
  }

  // Avautuva sisältö

  $('a.accordion-title').click(function(e) {
    e.preventDefault();
    var elm = $(this).next();
    $('div.accordion-content-wrap').not(elm).slideUp();
    $('a.accordion-title').not(this).removeClass('open');
    $(this).toggleClass('open');
    elm.slideToggle();
  });

  // Galleria

  var galleryLinks = document.querySelectorAll('.gallery a');
  if (galleryLinks.length > 0) {

    var numLinks = galleryLinks.length;
    var currentLink = 0;

    // Create the modal
    var modal = document.createElement('div');
    modal.classList.add('modal');
    modal.innerHTML = `
      <img class="modal-image" />
      <div class="modal-title"></div>
      <a class="modal-download" href="" download>Lataa kuva</a>
      <div class="modal-counter"></div>
      <div class="modal-prev">&#10094;</div>
      <div class="modal-next">&#10095;</div>
    `;
    document.body.appendChild(modal);

    var modalImage = modal.querySelector('.modal-image');
    var modalTitle = modal.querySelector('.modal-title');
    var modalDownload = modal.querySelector('.modal-download');
    var modalCounter = modal.querySelector('.modal-counter');
    var modalPrev = modal.querySelector('.modal-prev');
    var modalNext = modal.querySelector('.modal-next');

    // Show the modal when a link is clicked
    galleryLinks.forEach(function(link, index) {
      link.addEventListener('click', function(event) {
        event.preventDefault();
        currentLink = index;
        showModal(currentLink);
      });
    });

    // Show the modal with the current image
    function showModal(index) {
      var href = galleryLinks[index].getAttribute('href');
      var title = galleryLinks[index].getAttribute('title');
      var counter = (index + 1) + '/' + numLinks;
      modalImage.setAttribute('src', href);
      modalTitle.textContent = title;
      modalDownload.setAttribute('href', href);
      modalCounter.textContent = counter;
      modal.style.display = 'block';
    }

    // Hide the modal when the background is clicked
    modal.addEventListener('click', function(event) {
      if (event.target === modal) {
        modal.style.display = 'none';
      }
    });

    // Show the previous image
    modalPrev.addEventListener('click', function() {
      currentLink--;
      if (currentLink < 0) {
        currentLink = numLinks - 1;
      }
      showModal(currentLink);
    });

    // Show the next image
    modalNext.addEventListener('click', function() {
      currentLink++;
      if (currentLink >= numLinks) {
        currentLink = 0;
      }
      showModal(currentLink);
    });

    // Keyboard navigation
    document.addEventListener('keydown', function(event) {
      if (event.key === 'ArrowLeft') {
        currentLink--;
        if (currentLink < 0) {
          currentLink = numLinks - 1;
        }
        showModal(currentLink);
      } else if (event.key === 'ArrowRight') {
        currentLink++;
        if (currentLink >= numLinks) {
          currentLink = 0;
        }
        showModal(currentLink);
      } else if (event.key === 'Escape') {
        modal.style.display = 'none';
      }
    });

    // Pop-up functionality
    var popUpSection = document.querySelector('section.pop-up');
    if (popUpSection) {
      var popUpItems = document.querySelectorAll('.pop-up-item');
      popUpItems.forEach(function(item) {
        item.addEventListener('click', function(e) {
          e.preventDefault();
          var popupContent = item.querySelector('.pop-up-content').cloneNode(true);
          var popupBg = document.createElement('div');
          popupBg.classList.add('popup-bg');
          document.body.appendChild(popupBg);
          document.body.appendChild(popupContent);
          var closeBtn = document.createElement('a');
          closeBtn.setAttribute('href', '#');
          closeBtn.classList.add('close');
          closeBtn.textContent = 'Sulje';
          popupContent.appendChild(closeBtn);
          popupContent.style.top = (window.scrollY + window.innerHeight * 0.1) + 'px';
          popupBg.style.display = 'block';
          popupContent.style.display = 'block';

          // Close pop-up
          popupBg.addEventListener('click', closePopup);
          closeBtn.addEventListener('click', closePopup);
        });
      });

      function closePopup(e) {
        e.preventDefault();
        var popupBg = document.querySelector('.popup-bg');
        var popupContent = document.querySelector('body > .pop-up-content');
        if (popupBg) popupBg.remove();
        if (popupContent) popupContent.remove();
      }
    }
  }

  // Galleria END

  // Kirjautumislomakkeen placeholder tekstit
  const user = document.getElementById('user_login');
  const pass = document.getElementById('user_pass');
  if (user) user.placeholder = 'Käyttäjätunnus';
  if (pass) pass.placeholder = 'Salasana';

  // Näytä lisää uutisia 10 kerrallaan
  var list = document.getElementById('news-accordion');
  var btn  = document.getElementById('show-more-news-btn');
  if (list && btn) {
    var BATCH = parseInt(btn.getAttribute('data-batch'), 10) || 10;
    function updateButtonLabel() {
      var hiddenCount = list.querySelectorAll('.accordion-item[hidden]').length;
      if (hiddenCount <= 0) {
        btn.setAttribute('aria-expanded', 'true');
        var wrapper = btn.closest('.show-more-news');
        if (wrapper) { wrapper.parentNode.removeChild(wrapper); }
      } else {
        // Päivitä: Näytä 10 lisää (jäljellä N)
        btn.textContent = 'Näytä lisää uutisia';
      }
    }
    btn.addEventListener('click', function(e){
      e.preventDefault();
      var hiddenItems = list.querySelectorAll('.accordion-item[hidden]');
      var toShow = Math.min(BATCH, hiddenItems.length);
      for (var i = 0; i < toShow; i++) {
        hiddenItems[i].removeAttribute('hidden');
        hiddenItems[i].removeAttribute('data-hidden');
      }
      updateButtonLabel();
    });
    // Alustus
    updateButtonLabel();
  }
  // END Näytä lisää uutisia 10 kerrallaan

  // Tapahtuman single sivun kartta
  (function () {
    const el = document.getElementById('map');
    if (!el) return;
    const title  = (el.dataset.title  || '').trim();
    const street = (el.dataset.street || '').trim();
    const city   = (el.dataset.city   || '').trim();
    // Rakennetaan osoite ja Google iFrame -osoite
    const address = [title, street, city].filter(Boolean).join(', ');
    const q = encodeURIComponent(address);
    // t=m = map, z=15 = zoom (voit säätää), output=embed = upotus
    const src = `https://maps.google.com/maps?q=${q}&t=m&z=15&output=embed`;
    // Escaper pientä suojausta varten
    const esc = (s) => s
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#39;');
    // Rakenne
    el.innerHTML = `
      <div class="gmap-embed" role="region" aria-label="Kartta: ${esc(address)}">
        <iframe
          src="${src}"
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
          allowfullscreen
          title="Google-kartta: ${esc(address)}"
        ></iframe>
      </div>
    `;
  })();
  // END Tapahtuman single sivun kartta

  // Ankkurilinkistä haitarin avaus
  var h = decodeURIComponent(window.location.hash || '').replace('#', '');
  if (h) openAccordionById(h, true); 
}); // jQuery(document).ready

jQuery(window).resize(function() {
	win_w = jQuery(document).width();
  init_ui();
});

document.addEventListener("DOMContentLoaded", () => {
  // Lisää/poista sticky header
  window.addEventListener("scroll", () => {
    // Älä aja sticky-logiikkaa jos navi on auki
    if (document.body.classList.contains("navi-open")) {
      return;
    }
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    document.body.classList.toggle("sticky-header", scrollTop > 95);
  });
});

jQuery(window).on('hashchange', function() {
  var h = decodeURIComponent(window.location.hash || '').replace('#', '');
  if (h) openAccordionById(h, true);
});

function init_ui() {

}

function carousel_play() {
  change_carousel(next_carousel_index);
  if ( carousel_current_index < (carousel_num_items - 1) )
    next_carousel_index = carousel_current_index + 1;
  else
    next_carousel_index = 0;
}

function change_carousel(i) {
  carousel_change = true;
  var child_index = i + 1;
  var new_bg = jQuery('div.carousel-items > div:nth-child(' + child_index + ')').attr('style');
  var new_backgroung_color = jQuery('div.carousel-items > div:nth-child(' + child_index + ')').data('kuvansavy');
  jQuery('div.next-item').attr('style', new_bg).show();
  jQuery('div.current-item').fadeOut(carousel_fade_speed, function() {
    jQuery('div.current-item').attr('style', new_bg).show();
    carousel_change = false;
  });
  // Päivitetään teksti
  carousel_content_html = jQuery('div.carousel-items > div:nth-child(' + child_index + ')').html();
  jQuery('div.item-text').fadeOut(carousel_fade_speed, function() { 
    jQuery('div.item-text div').html(carousel_content_html);
    jQuery('div.item-text').fadeIn(carousel_fade_speed) 
  });
  // Change navi
  jQuery('div.carousel-navi a').removeClass('current');
  jQuery('div.carousel-navi a:nth-child(' + child_index + ')').addClass('current');
  // Other stuff
  carousel_current_index = i;
}

function set_carousel_navi() {
  var carousel_navi_count = jQuery('div.carousel-items').children().length;
  for ( var i = 0; i < carousel_navi_count; i++ ) {
    jQuery('div.carousel-navi').prepend('<a href="#">' + i + '</a>');
  }
  if ( carousel_navi_count > 1 ) {
    jQuery('div.carousel-navi, a.next-item-link, a.prev-item-link').show();
  }
  jQuery('div.carousel-navi a:nth-child(1)').addClass('current');
}

function openAccordionById(id, doScroll) {
  var $item = jQuery('#' + id + '.accordion-item');
  if (!$item.length) return;
  var $title = $item.children('a.accordion-title');
  var $wrap  = $item.children('.accordion-content-wrap');
  jQuery('div.accordion-content-wrap').not($wrap).slideUp(0);
  jQuery('a.accordion-title').not($title).removeClass('open');
  $title.addClass('open');
  if (doScroll === false) {
    $wrap.show();
  } else {
    $wrap.stop(true, true).slideDown(200);
  }
  if (doScroll !== false) {
    var y = Math.max(0, $item.offset().top - HEADER_OFFSET);
    jQuery('html, body').stop(true).animate({ scrollTop: y }, 250);
  }
}